module.exports = __webpack_public_path__ + "static/img/289.07d870b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/289.png
// module id = A3p/
// module chunks = 0